<template>
  <div class="jsycDetailPopup">
    <transition
      name="van-fade"
      mode="out-in"
    >
      <div
        v-if="step === 0"
        key="loading"
      >
        <van-row
          class="popup-float"
          :style="{
            width: 'calc(100% - 32px)',
            top: '-50px'
          }"
        >
          <van-notice-bar
            class="round-sm"
            left-icon="volume"
            :text="noticeMessage[step]"
          />
        </van-row>
        <van-row>
          <van-loading
            class="inline-block"
            text-size="22"
            color="#1989fa"
            @click="changeOrderStatus('1')"
          >
            <span class="font-bold black">正在呼叫</span>
          </van-loading>
        </van-row>

        <van-button
          class="mt5"
          type="default"
          block
          @click="cancel"
        >
          取消订单
        </van-button>
      </div>


      <div
        v-else-if="step === 1"
        key="waiting"
      >
        <van-row
          class="popup-float"
          :style="{
            width: 'calc(100% - 32px)',
            top: '-60px'
          }"
        >
          <van-notice-bar
            class="round-sm"
            left-icon="volume"
            :text="noticeMessage[step]"
            mode="link"
            :scrollable="false"
            wrapable
            :style="{
              fontSize: '11px',
              lineHeight: '16px',
              padding: '8px 12px'
            }"
          />
        </van-row>

        <van-row>
          <van-col
            :span="orderStatus == 6 ? 14 : 24"
            class="font-bold font22"
          >
            <span
              @click="changeOrderStatus('4')"
              v-if="orderStatus == 1 || orderStatus == 3"
            >司机已接单</span>
            <span
              @click="changeOrderStatus('5')"
              v-else-if="orderStatus == 4"
            >司机已到达 , 等候您上车</span>
            <span
              @click="changeOrderStatus('6')"
              v-else-if="orderStatus == 5"
            >行程已开始</span>
            <span
              @click="changeOrderStatus('1')"
              v-else-if="orderStatus == 6"
            >订单完成</span>
          </van-col>
          <van-col
            v-if="orderStatus == 6"
            span="10"
            class="text-right"
          >
            <span class="font-bold font26">{{ data.totalAmount }}</span>
            <span class="font12"> 元</span>&nbsp;
            <!-- 没有绑定事件， 先注释掉  2023年4月4日 15:41:34
           <van-icon
              name="arrow"
              class="gray vertical-middle"
            />-->
          </van-col>
        </van-row>

        <van-row class="font12 gray">
          <!-- 取消规则 -->
          <span v-if="(orderStatus == 1 || orderStatus == 3 || orderStatus == 4) && data.ruleMsg">
            {{ data.ruleMsg }}
            <van-icon
              name="arrow"
              class="vertical-middle"
            />
          </span>
          <span v-else-if="orderStatus == 5">
            行程结束获取实际支付金额
          </span>
          <span v-else-if="orderStatus == 6">
            订单已完成
          </span>
        </van-row>

        <!-- 司机Panel -->
        <van-row class="driving-wrapper">
          <van-col span="18">
            <div class="license-plate linear-main1">
              <div class="van-hairline--surround">
                {{ data.licenseNumber }}
              </div>
            </div>
            <van-row class="font-bold mt5">
              {{ data.vehiclesDesc || data.typeDesc }}
              {{ data.vehiclesColor }}
            </van-row>
            <van-row class="mt5 font12 gray">
              由
              <span class="font14 black">
                <img
                  class="round-sm vertical-middle"
                  width="14"
                  :src="data.priceFromUrl"
                >
                {{ data.priceFromName }}·{{ data.vehicleTypeName | substring(0, 2) }}
              </span>
              为你提供服务
              资质
              <!-- 没有绑定事件，暂时注释掉 2023年4月4日 14:33:41
             <van-icon
                name="arrow"
                class="vertical-middle"
              />-->
            </van-row>
          </van-col>
          <van-col
            class="text-center"
            span="6"
          >
            <van-image
              width="60"
              height="60"
              round
              :src="data.driverPicUrl ? data.driverPicUrl : require('Assets/images/car/driverAvatar.png')"
              :error-icon="require('Assets/images/car/driverAvatar.png')"
            />
            <p>{{ data.driverAlias }}</p>
          </van-col>
        </van-row>

        <!-- 订单操作 -->
        <van-row class="button-group van-hairline--surround mt5">
          <van-col span="8">
            <a
              class="black"
              :href="`tel:${data.driverTel}`"
            >
              <van-icon name="phone" />
              联系司机
            </a>
          </van-col>
          <van-col
            span="8"
            @click="invoice"
            v-if="orderStatus == 6"
          >
            <van-icon name="column" />
            我要开票
          </van-col>
          <van-col
            span="8"
            @click="cancel"
            v-if="data.showCancelButton == 1 && orderStatus != 5 && orderStatus != 6"
          >
            <van-icon name="clear" />
            取消订单
          </van-col>
          <van-col
            span="8"
            class="red"
          >
            <van-icon name="bell" />
            一键报警
          </van-col>
          <van-col span="8">
            <van-icon name="friends" />
            紧急联系人
          </van-col>
          <van-col span="8">
            <van-icon name="share" />
            行程分享
          </van-col>
          <van-col
            span="8"
            v-if="orderStatus == 6"
            @click="toPay">
            <van-icon name="gold-coin" />
            费用明细
          </van-col>
        </van-row>
      </div>


      <div
        v-else-if="step === 10"
        key="cancel"
      >
        <van-row
          class="font-bold font22"
          @click="changeOrderStatus('0')"
        >
          订单已取消
        </van-row>
        <van-row class="mt5 font12 gray">
          <span v-if="orderStatus === '7'">
            {{ data.qxyy || '司机取消' }}
          </span>
          <span v-else-if="orderStatus === '8'">
            {{ data.qxyy || '乘客取消' }}
          </span>
          <span v-else-if="orderStatus === '9'">
            <!-- 没有司机接单，超时系统自动拒单 ！ -->
            司机取消订单,请重新叫车
          </span>
        </van-row>

        <div class="address-panel mt5">
          <van-row>
            <van-col span="6">
              出发地 :
            </van-col>
            <van-col span="18">
              {{ data.scdd }}
            </van-col>
          </van-row>
          <van-row>
            <van-col span="6">
              目的地 :
            </van-col>
            <van-col span="18">
              {{ data.xcdd }}
            </van-col>
          </van-row>
          <van-row>
            <van-col span="6">
              用车时间 :
            </van-col>
            <van-col span="18">
              {{ data.startTimeDate.monDay }} {{ data.startTimeDate.hm }}
            </van-col>
          </van-row>
        </div>

        <!-- 没有任何绑定事件，暂时注释 2023年4月4日 14:07:40
        <van-row class="button-group van-hairline&#45;&#45;surround mt5">
          <van-col span="12">
            <van-icon name="phone" />
            取消规则
          </van-col>
          <van-col span="12">
            <van-icon name="clear" />
            我要反馈
          </van-col>
        </van-row>-->

        <ldButton
          main
          size="lg"
          class="mt5"
          @click.native="$emit('reset')"
        >
          重新叫车
        </ldButton>
      </div>
    </transition>

    <van-row class="mt5 gray">
      <van-col span="12">
        乘车人 {{ data.phoneNumber }}
        <!--<van-icon  暂时去掉 > icon标识 2023年4月4日 11:17:50
          name="arrow"
          class="vertical-middle"
        />-->
      </van-col>
      <van-col
        span="12"
        class="text-right"
      >
        订单号 {{ data.orderNo }}
      </van-col>
    </van-row>

    <!-- 原因  -->
    <cancel-rason
      ref="cancelRason"
      @selected="chooseRason"
    />
  </div>
</template>

<script>
import { Popup, Tabs, Tab, Image, Field, Checkbox, Tag, Button, NoticeBar, Loading } from 'vant'
import ldButton from 'Common/ldButton'
import cancelRason from './components/cancelRason.vue'

export default {
  name: 'JsycDetailPopup',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    [Popup.name]: Popup,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Image.name]: Image,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Loading.name]: Loading,
    [NoticeBar.name]: NoticeBar,
    ldButton, cancelRason
  },
  data () {
    return {
      step: null,
      noticeMessage: {
        0: '近期乘车请佩戴口罩',
        1: '行程中的费用仅支持线上支付。如产生高速费用等附加费，请与司机商议好支付方式。近期乘车请佩戴口罩'
      },
      cancelTips: {
        0: '正在全力呼叫车辆，重新叫车将等待更长时间，确认要取消吗？',
        1: '司机赶在接您的路上，重新叫车将等待更长时间，确认要取消吗？',
      }
    }
  },
  computed: {
    orderStatus: vm => vm.data.orderStatus,
  },
  mounted () {
    console.log('jsycDetailPopup Component - mounted')
  },
  methods: {
    changeOrderStatus (i) {
      return
      this.data.orderStatus = i
    },
    invoice () {
      this.$toast('请联系首页右上角 - 客服')
    },
    cancel () {
      this.$dialog.confirm({
        message: this.cancelTips[this.step],
        confirmButtonText: '暂不取消',
        cancelButtonText: '确认取消'
      }).catch(async () => {
        if (this.step == 0) {
          this.$refs.cancelRason.toggle()
        } else {
          try {
            let { data = {} } = this.$api['carOrder/getCancelFee']({ orderId: this.data.id })
            if (data.khFine) {
              this.$dialog.confirm({
                title: '提示',
                message: `取消订单会产生罚金￥${data.khFine}，是否继续取消订单？`,
              }).then(() => {
                this.$refs.cancelRason.toggle()
              }).catch(() => {
                // on cancel
              })
            } else {
              this.$dialog.confirm({
                title: '提示',
                message: '是否取消订单',
              }).then(() => {
                this.$refs.cancelRason.toggle()
              }).catch(() => {
                // on cancel
              })
            }
          } catch (err) {
            if (err.errCode === '1801') {
              this.$dialog.confirm({
                title: '提示',
                message: '当前状态下取消用车罚金暂不确定，具体以取消后的为准。是否继续取消？',
              }).then(() => {
                this.$refs.cancelRason.toggle()
              }).catch(() => {
                // on cancel
              })
            }
          }
        }
      })
    },
    async chooseRason (info) {
      // this.changeOrderStatus('8')
      // return
      if (info && info.value) {
        this.showReason = false
        await this.$api['carOrder/orderCancel']({
          orderId: this.data.id,
          qxbh: info.value, // 取消原因id
          qxyy: info.text, // 取消原因描述
          sfqx: 1 // 是否取消
        })

        this.$emit('getDetail')
      }
    },
    // 跳转到详情界面支付
    toPay () {
      console.warn(this.data.id,"this.data.id")
      this.$router.push({
        path: '/car/carOrderDetail',
        query: { orderId: this.data.id }
      })
    }
  },
  watch: {
    // 订单状态: 0已预订 1已派车 2改派中 3司机出发 4司机到达 5开始服务 6订单完成 7司机取消 8已取消 9拒单
    orderStatus: {
      handler (val) {
        if (['0', '2'].indexOf(val) > -1) {
          this.step = 0
          this.$emit('loading') // 正在呼叫
        } else if (['1', '3', '4'].indexOf(val) > -1) {
          this.step = 1
          this.$emit('waiting') // 司机在来的路上了
        } else if (['5'].indexOf(val) > -1) {
          this.step = 1
          this.$emit('taking') // 司机到了 客人上车 开始导航
        } else if (['6'].indexOf(val) > -1) {
          this.step = 1
          this.$emit('complete') // 订单完成了
          this.$emit('getDetail') // 订单完成回显获取实际支付金额
        } else if (['7', '8', '9'].indexOf(val) > -1) {
          this.step = 10
          this.$emit('cancel')
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="less">
.jsycDetailPopup {
  padding: 16px;
  // min-height: 270px;

  .mt5 {
    margin-top: 12px;
  }

  .driving-wrapper {
    margin-top: 20px;

    .license-plate {
      display: inline-block;
      width: 120px;
      padding: 4px;
      line-height: 36px;
      text-align: center;
      border-radius: 4px;
      color: white;
      font-size: 20px;
    }

    .van-image__error {
      background-color: #e5e5e5;
    }
  }

  .address-panel {
    padding: 8px 16px;
    font-size: 12px;
    border-radius: @border-radius-sm;
    background-color: @color-background-gray;

    .van-col {
      line-height: 32px;
    }

    .van-col:nth-child(2) {
      text-align: right;
    }
  }

  .button-group {
    font-size: 12px;
    overflow: auto;
    border-radius: @border-radius-sm;

    .van-icon {
      vertical-align: text-top;
    }

    .van-col {
      line-height: 36px;
      text-align: center;
    }

    .van-col:active {
      background-color: #f2f3f5;
    }
  }
}
</style>
